/** Public CV download (generated via `npm run generate-cv`). */
export const CV_PDF_PATH = '/Derrick-Teye-CV.pdf';
export const CV_PDF_FILENAME = 'DERRICK TEYE CV.pdf';